import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {GetUserRequest, PostUserRequest, User} from '../models/user';
import {Simple200Response} from '../models/general';

@Injectable()
export class UserService {

  constructor(private httpClient: HttpClient) {
  }

  getUser({accessToken}: GetUserRequest): Observable<User> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${accessToken}`});
    const url = `${environment.mobileAppHost}users/self`;

    return this.httpClient
      .get<User>(url, {headers});
  }

  postUser({email, first_name, last_name, password, invitation_code, invitation_type}: PostUserRequest): Observable<Simple200Response> {
    const url = `${environment.awairAccountHost}users`;
    const body = {
      email,
      first_name,
      last_name,
      password,
      invitation_code,
      invitation_type
    };

    return this.httpClient
      .post<{ message: string }>(url, body);
  }
}
